import { useState } from "react";
import { loginInput } from "@akhshy/types";
import { useAuth } from "../../lib/auth.tsx";
import { useForm } from "../../lib/useForm.ts";
import { FormField } from "../molecules/FormField.tsx";
import { Input } from "../atoms/Input.tsx";
import { Button } from "../atoms/Button.tsx";

export function LoginForm() {
  const { login } = useAuth();
  const { errors, submitting, submit } = useForm(loginInput, "Welcome back");
  const [passcode, setPasscode] = useState("");

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    void submit({ passcode }, async (parsed) => {
      await login(parsed);
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <p className="eyebrow">Akhshy Ganesh</p>
      <h1 style={{ fontSize: "1.6rem", margin: "0 0 6px" }}>Desk admin</h1>
      <p style={{ color: "var(--ink-soft)", margin: "0 0 22px", fontSize: "0.92rem" }}>
        Enter your passcode to manage the desk.
      </p>
      <FormField label="Passcode" htmlFor="passcode" error={errors["passcode"]}>
        <Input
          id="passcode"
          type="password"
          autoFocus
          autoComplete="current-password"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
        />
      </FormField>
      <Button variant="primary" type="submit" disabled={submitting} style={{ width: "100%", justifyContent: "center" }}>
        {submitting ? "Checking…" : "Log in"}
      </Button>
    </form>
  );
}
